import {React, observer, Fragment} from '@api'
import {Tooltip} from '@material-ui/core'
import {usePresentationModeContentStore} from './'
import {PresentationPageView} from './pageContents'
import * as css from './PageThumbnailsNavigator.css'

export const PageThumbnailsNavigator = observer(function PageThumbnailsNavigator() {
  const {settings: {showNavigator}, pages, hasContentLoaded} = usePresentationModeContentStore()

  if (!showNavigator) return null

  return (<div className={css.navigator}>
    <div className={css.contents}>
      {hasContentLoaded && pages.map((p, i) => <Tooltip
        enterNextDelay={300} enterDelay={300} // So the size change can finish
        key={i}
        title={`Page ${i + 1}`}
        placement='top'>
        <div className={css.wrapper}>
          <PresentationPageView className={css.page} thumbnail page={p}/>
        </div>
      </Tooltip>)}
    </div>
  </div>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/PageThumbnailsNavigator.tsx